import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import DefaultLayout from '../components/molecules/common/DefaultLayout'
import LabeledInput from '../components/molecules/LabeledInput'
import { useBack } from '../hooks/useBack'
import { useDropdown } from '../hooks/useDropdown'
import DetailDropdown from '../components/molecules/DetailDropdown'
import { useNavigate, useParams } from 'react-router-dom'
import { useClickOutside } from '../hooks/useClickOutside'
import { useModal } from '../hooks/useModal'
import DeleteModal from '../components/molecules/common/DeleteModal'
import EditModal from '../components/molecules/EditModal'
import { deleteWord, getWord } from '../api/word'
import Text from '../components/atoms/Text'
import { logEvent } from '../utils/eventLogger'

const Wrapper = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
  text-align: left;
`

const WordDetail = () => {
  const navigate = useNavigate();
  const goBack = useBack(); // 뒤로가기 훅 호출
  const dropdown = useDropdown(); // 드롭다운 훅 호출
  const dropdownRef =useRef(null); //외부 클릭 감지를 위한 ref 
  useClickOutside(dropdownRef, () => dropdown.close()); // 외부 클릭 감지 훅 호출
  const modal = useModal(); // 모달 훅 호출
  
  // 메뉴 클릭
  const handleMenuClick = () => {
    dropdown.open();
  }

  // 메뉴 > 수정 선택
  const handleClickEdit = () => {
    dropdown.close();
    modal.open("edit")
  }

  // 메뉴 > 삭제 선택
  const handleClickDelete = () => {
    dropdown.close();
    modal.open("delete");
  }

  // 수정 모달 > 수정 선택
  const handleEditSubmit = () => {
    modal.close();
    // navigate에 id 포함
    navigate(`/words/${id}/edit`)
  }
  
  // 삭제 모달 > 삭제 선택
  const handleDeleteSubmit = async() => {
    try {
      await deleteWord(id);
      
      // 로그 기록
      logEvent("dict_delete", {
        wordDictId: id
      })

      modal.close();
      navigate('/words');  
    } catch (err) {
      console.error(err);
      alert('삭제 중 오류가 발생했습니다. 다시 시도해주세요.');
    }
  }

  // 모달 컴포넌트 object literal
  const modalComponents = {
    edit: () => <EditModal onClose={modal.close} onConfirm={handleEditSubmit}/>,
    delete: () => <DeleteModal onClose={modal.close} onConfirm={handleDeleteSubmit}/>
  }
  
  const CurrentModal = modal.modalType ? modalComponents[modal.modalType] : null;
  
  const { id } = useParams();
  const [wordInfo, setWordInfo] = useState({ word: '', meaning: '', category:'' });
  
  useEffect(() => {
      const fetchWord = async() => {
        try {
          const wordData = await getWord(id);
          setWordInfo({
            word: wordData.kr_transcript,
            meaning: wordData.meaning,
            category: wordData.category
          })
          // console.log(wordData)
        } catch (err) {
          console.error(err);
          if (err.response?.status === 400) {
            alert("접근 권한이 없습니다.");
            navigate('/words', { replace: true });
          }
        }
      };
      fetchWord();
    }, [id]);

  const isCard = wordInfo.category === 'AAC'

  return (
    <DefaultLayout
      headerType="sub" 
      onBack={goBack}
      variant="action"
      onMenuClick={handleMenuClick}>
      {dropdown.isOpen && 
        <DetailDropdown 
          ref={dropdownRef}
          isCard={isCard}
          onEdit={handleClickEdit}
          onDelete={handleClickDelete}/>}
      <Wrapper>
        <LabeledInput 
          label="발화내용" 
          value={wordInfo.word} 
          required={true}
          readOnly={true}/>
        <LabeledInput 
          label="의미단어" 
          value={wordInfo.meaning}
          required={true}
          readOnly={true}/>
        {isCard && 
          <Text 
            color="alternative"
            variant="body2">
              단어 카드 기록에서 등록한 단어는 수정할 수 없습니다.
          </Text>
        }
      </Wrapper>
      {CurrentModal && <CurrentModal/>}
    </DefaultLayout>
  )
}

export default WordDetail
